module.exports = __webpack_public_path__ + "static/media/more-og-romsdal.52db5259.jpg";